import React from "react";
import { makeStyles } from "@material-ui/core";
import { useSpring, animated, config } from "react-spring";

import SubPanelContent from "./SubPanelContent";

function ExpandablePanel({ productTypes, open, commercialCategories }) {
  const classes = useStyle();
  const { transform } = useSpring({
    transform: open ? "translateY(100%)" : "translateY(-3%)",
    config: config.stiff,
  });
  return (
    <animated.div
      style={{
        transform,
      }}
      className={classes.container}
    >
      <div className={classes.inner}>
        <SubPanelContent productTypes={productTypes} commercialCategories={commercialCategories} />
      </div>
    </animated.div>
  );
}

const useStyle = makeStyles(() => ({
  container: {
    backfaceVisibility: "hidden",
    position: "absolute",
    zIndex: -1,
    width: "100%",
    bottom: 0,
    background: "white",
    paddingLeft: "15%",
    paddingTop: 20,
    paddingBottom: 50,
    boxShadow: "0px 1px #e6e6e6",
  },
  inner: {
    paddingTop: 50,
    paddingBottom: 50,
  },
}));

export default ExpandablePanel;
